"use client";

import { ReactNode } from "react";
import { cn } from "@drpcrd/utils/shared";
import Link from "next/link";

type ActionBannerProps = {
  children: ReactNode;
  rightElement?: ReactNode;
  className?: string;
  href?: string;
  onClick?: () => void;
};

/**
 * Flexible banner component for displaying important information with optional actions.
 * Uses slot-based pattern for maximum flexibility.
 * Can be rendered as a link when href is provided.
 */
export const ActionBanner = ({
  children,
  rightElement,
  className,
  href,
  onClick,
}: ActionBannerProps) => {
  const content = (
    <div className="flex w-full items-center justify-start gap-2">
      <div className="flex flex-1 items-center gap-2">{children}</div>
      {rightElement && <div className="shrink-0">{rightElement}</div>}
    </div>
  );

  const baseClassName = cn(
    "flex w-full items-center justify-start self-stretch border-y bg-pink-50 px-3 py-1.5 py-2",
    className,
  );

  if (href) {
    return (
      <Link href={href} className={baseClassName}>
        {content}
      </Link>
    );
  }

  return (
    <div className={baseClassName} onClick={onClick}>
      {content}
    </div>
  );
};
